

<div class="wrapper" controlErrorContainer>
  <div class="switcher" (click)="showModal = !showModal" #switcherElement>
    <span class="flag" [ngClass]="'flag-code-' + selectedCountry.co"></span>
    +{{ selectedCountry.ph }}
  </div>

  <input class="gl-input" type="text" [formControl]="phoneControl" #inputElement>
</div>


<div class="modal" *ngIf="showModal">
  <p *ngFor="let item of countryList" (click)="setCountry(item)">
    <span class="flag" [ngClass]="'flag-code-' + item.co"></span>
    {{ item.na }} +{{item.ph}}
  </p>
</div>
